var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("弼马智能")]),_c('h2',[_vm._v("路径分析")]),_c('p',[_vm._v("潘川路罗东路 至 海亭路华驿路")])])}]

export { render, staticRenderFns }